import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M10.71 9.71L15 5.41V23a1 1 0 002 0V5.41l4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42l-6-6a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21l-6 6a1 1 0 001.42 1.42z"/><path d="M29 22a1 1 0 00-1 1v5H4v-5a1 1 0 00-2 0v5.5A1.5 1.5 0 003.5 30h25a1.5 1.5 0 001.5-1.5V23a1 1 0 00-1-1z"/>';
export var UploadOutlineSVG = function UploadOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
UploadOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(UploadOutlineSVG);